///
/// EarthBrowser
///
/// Created by Matt Giger on 9/11/2026
/// Copyright (c) 2026 Geodata Labs
///

/// Typed GL constants so client code never references WebGL2RenderingContext
/// directly. Values are the standard WebGL enum values, so they can be passed
/// straight through to any API that takes a GLenum.

/** Primitive draw modes (gl.drawArrays / gl.drawElements) */
export enum DrawMode {
	Points = 0x0000,
	Lines = 0x0001,
	LineLoop = 0x0002,
	LineStrip = 0x0003,
	Triangles = 0x0004,
	TriangleStrip = 0x0005,
	TriangleFan = 0x0006,
}

/** Texture minification/magnification filters */
export enum TextureFilter {
	Nearest = 0x2600,
	Linear = 0x2601,
	NearestMipmapNearest = 0x2700,
	LinearMipmapNearest = 0x2701,
	NearestMipmapLinear = 0x2702,
	LinearMipmapLinear = 0x2703,
}

/** Texture coordinate wrap modes */
export enum TextureWrap {
	Repeat = 0x2901,
	ClampToEdge = 0x812f,
	MirroredRepeat = 0x8370,
}

/** Pixel transfer formats (the "format" argument of texImage2D) */
export enum PixelFormat {
	Red = 0x1903,
	RG = 0x8227,
	RGB = 0x1907,
	RGBA = 0x1908,
	Luminance = 0x1909,
	RedInteger = 0x8d94,
}

/** Texture internal storage formats */
export enum InternalFormat {
	RGBA = 0x1908,	// unsized, matches PixelFormat.RGBA
	RGB8 = 0x8051,
	RGBA8 = 0x8058,
	R8 = 0x8229,
	RG8 = 0x822b,
	R8I = 0x8231,
	R8UI = 0x8232,
	R16I = 0x8233,
	R16UI = 0x8234,
	R32I = 0x8235,
	R32UI = 0x8236,
	R32F = 0x822e,
	RG32F = 0x8230,
}

/** Vertex/pixel component data types (also glTF accessor componentType values) */
export enum ComponentType {
	Byte = 0x1400,
	UnsignedByte = 0x1401,
	Short = 0x1402,
	UnsignedShort = 0x1403,
	Int = 0x1404,
	UnsignedInt = 0x1405,
	Float = 0x1406,
}

/** Blend function factors (gl.blendFunc) */
export enum BlendFactor {
	Zero = 0,
	One = 1,
	SrcColor = 0x0300,
	OneMinusSrcColor = 0x0301,
	SrcAlpha = 0x0302,
	OneMinusSrcAlpha = 0x0303,
	DstAlpha = 0x0304,
	OneMinusDstAlpha = 0x0305,
	DstColor = 0x0306,
	OneMinusDstColor = 0x0307,
}
